import React from "react";
import HeaderBis from "../components/layout/headerbis";
import backgroundImage from "./../assets/img/header1.webp";
import FAQItem from "./../components/elements/faqitem.jsx";

const FAQ = () => {
  const faqs = [
    {
        question: "Question à poser pour y répondre",
        answer: "Lorem ipsum dolor sit aspernatur cupiditate perferendis maiores consequuntur facilis nihil pariatur distinctio doloribus, nam eos deleniti! Deleniti doloremque libero eaque quisquam minima animi labore nihil quas sapiente unde accusamus voluptates velit, veniam cupiditate quod repudiandae odit blanditiis officiis ipsam!"
    },
    {
      question: "Question à poser pour y répondre",
      answer: "Lorem ipsum dolor sit aspernatur cupiditate perferendis maiores consequuntur facilis nihil pariatur distinctio doloribus, nam eos deleniti! Deleniti doloremque libero eaque quisquam minima animi labore nihil quas sapiente unde accusamus voluptates velit, veniam cupiditate quod repudiandae odit blanditiis officiis ipsam!"
    },
    {
      question: "Question à poser pour y répondre",
      answer: "Lorem ipsum dolor sit aspernatur cupiditate perferendis maiores consequuntur facilis nihil pariatur distinctio doloribus, nam eos deleniti! Deleniti doloremque libero eaque quisquam minima animi labore nihil quas sapiente unde accusamus voluptates velit, veniam cupiditate quod repudiandae odit blanditiis officiis ipsam!"
    },
    {
      question: "Question à poser pour y répondre",
      answer: "Lorem ipsum dolor sit aspernatur cupiditate perferendis maiores consequuntur facilis nihil pariatur distinctio doloribus, nam eos deleniti! Deleniti doloremque libero eaque quisquam minima animi labore nihil quas sapiente unde accusamus voluptates velit, veniam cupiditate quod repudiandae odit blanditiis officiis ipsam!"
    },
    {
      question: "Question à poser pour y répondre",
      answer: "Lorem ipsum dolor sit aspernatur cupiditate perferendis maiores consequuntur facilis nihil pariatur distinctio doloribus, nam eos deleniti! Deleniti doloremque libero eaque quisquam minima animi labore nihil quas sapiente unde accusamus voluptates velit, veniam cupiditate quod repudiandae odit blanditiis officiis ipsam!"
    }, 
    {
      question: "Question à poser pour y répondre",
      answer: "Lorem ipsum dolor sit aspernatur cupiditate perferendis maiores consequuntur facilis nihil pariatur distinctio doloribus, nam eos deleniti! Deleniti doloremque libero eaque quisquam minima animi labore nihil quas sapiente unde accusamus voluptates velit, veniam cupiditate quod repudiandae odit blanditiis officiis ipsam!"
    },
    {
      question: "Question à poser pour y répondre",
      answer: "Lorem ipsum dolor sit aspernatur cupiditate perferendis maiores consequuntur facilis nihil pariatur distinctio doloribus, nam eos deleniti! Deleniti doloremque libero eaque quisquam minima animi labore nihil quas sapiente unde accusamus voluptates velit, veniam cupiditate quod repudiandae odit blanditiis officiis ipsam!"
    },
    {
      question: "Question à poser pour y répondre",
      answer: "Lorem ipsum dolor sit aspernatur cupiditate perferendis maiores consequuntur facilis nihil pariatur distinctio doloribus, nam eos deleniti! Deleniti doloremque libero eaque quisquam minima animi labore nihil quas sapiente unde accusamus voluptates velit, veniam cupiditate quod repudiandae odit blanditiis officiis ipsam!"
    },
    {
      question: "Question à poser pour y répondre",
      answer: "Lorem ipsum dolor sit aspernatur cupiditate perferendis maiores consequuntur facilis nihil pariatur distinctio doloribus, nam eos deleniti! Deleniti doloremque libero eaque quisquam minima animi labore nihil quas sapiente unde accusamus voluptates velit, veniam cupiditate quod repudiandae odit blanditiis officiis ipsam!"
    },
    {
      question: "Question à poser pour y répondre",
      answer: "Lorem ipsum dolor sit aspernatur cupiditate perferendis maiores consequuntur facilis nihil pariatur distinctio doloribus, nam eos deleniti! Deleniti doloremque libero eaque quisquam minima animi labore nihil quas sapiente unde accusamus voluptates velit, veniam cupiditate quod repudiandae odit blanditiis officiis ipsam!"
    },   
];
  return (
    <div>
      <HeaderBis 
        backgroundImage={backgroundImage}
        title="F.A.Q"
        desc="les questions les plus fréquentes"
      />
      <div className="flex flex-col justify-center bg-[#FAFAFA] text-[#595959] p-8 min-h-screen">
          <div className="max-w-[20rem] sm:max-w-[30rem] md:max-w-[42rem] md:w-[42rem] mx-auto space-y-4">
          {faqs.map((faq, index) => (
              <FAQItem key={index} question={faq.question} answer={faq.answer} />
          ))}
          </div>
      </div>
    </div>
  );
}

export default FAQ;